import { Button, Menu, MenuItem, Popover } from "@blueprintjs/core";
import React from "react";

type DownloadMenuProps = {
    readonly onDownloadCSV: () => void;
    readonly onDownloadImage: () => void;
};

export const DownloadMenu: React.FC<DownloadMenuProps> = ({
    onDownloadCSV,
    onDownloadImage
}) => (
    <Popover
        content={
            <Menu>
                <MenuItem
                    icon="download"
                    text="Download as CSV"
                    onClick={onDownloadCSV}
                />
                <MenuItem
                    icon="download"
                    text="Download as PNG"
                    onClick={onDownloadImage}
                />
            </Menu>
        }
        placement="bottom-end"
    >
        <Button size="small" variant="minimal" icon="download" />
    </Popover>
);
